import { create } from "zustand";

export const useApprovalTimelineDrawer = create((set) => ({
  open: false,
  code: "",
  createdBy: "",
  createdDate: "",
  timelines: [],
  statusText: "",
  handleOpen: (code, createdBy, createdDate, timelines, statusText) =>
    set({
      open: true,
      code,
      createdBy,
      createdDate,
      timelines,
      statusText,
    }),
  handleClose: () =>
    set({
      open: false,
      code: "",
      createdBy: "",
      createdDate: "",
      timelines: [],
      statusText: "",
    }),
}));
